import AccountFormContainer from './AccountFormContainer';

export default AccountFormContainer;
